import { useEffect, useState } from "react";
import sdk from "@farcaster/miniapp-sdk";

/**
 * Button to prompt user to add the miniapp to Farcaster.
 * Renders nothing if not in Farcaster or already added.
 */
export function FarcasterAddButton() {
  const [showButton, setShowButton] = useState(false);
  const [isAdding, setIsAdding] = useState(false);

  useEffect(() => {
    const checkContext = async () => {
      try {
        const context = await sdk.context;
        // Show button only if in Farcaster and not yet added
        if (context && !context.client?.added) {
          setShowButton(true);
        }
      } catch {
        // Not in Farcaster
      }
    };

    checkContext();
  }, []);

  const handleAdd = async () => {
    if (isAdding) return;
    setIsAdding(true);

    try {
      await sdk.actions.addFrame();
      setShowButton(false);
    } catch (error) {
      console.error("[Farcaster] Failed to add app:", error);
    } finally {
      setIsAdding(false);
    }
  };

  if (!showButton) return null;

  return (
    <button
      onClick={handleAdd}
      disabled={isAdding}
      className="flex items-center gap-4 rounded-lg bg-white p-4 text-left shadow-sm ring-1 ring-subtle-light dark:bg-subtle-dark dark:ring-0 w-full hover:opacity-90 transition-opacity disabled:opacity-50"
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-purple-500/10 dark:bg-purple-500/20">
        <span className="material-symbols-outlined text-purple-500">
          notifications_active
        </span>
      </div>
      <div className="flex-1">
        <p className="font-bold">Enable Notifications</p>
        <p className="text-sm text-content-light/70 dark:text-content-dark/70">
          Get updates on your challenges.
        </p>
      </div>
      {isAdding ? (
        <span className="material-symbols-outlined text-content-light/50 dark:text-content-dark/50 animate-spin">
          progress_activity
        </span>
      ) : (
        <span className="material-symbols-outlined text-content-light/50 dark:text-content-dark/50">
          chevron_right
        </span>
      )}
    </button>
  );
}
